import styled from 'styled-components';
import { PolarisBreakPoint } from '@/constants/enum';

export const BannerContainer = styled.div``;

export const BannerContent = styled.div`
  background: linear-gradient(92deg, rgba(200, 231, 255, 0.2) 48.61%, rgba(71, 149, 255, 0.2) 100%), var(--p-color-bg-surface);
  border-radius: 12px;
  padding: 16px 48px 16px 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  border: 1px solid #e0e0e0;
  position: relative;
`;

export const Content = styled.div<{ $justifyContent?: string; $gap?: string; $gapResponsive?: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $justifyContent }) => $justifyContent || 'space-between'};
  gap: ${({ $gap }) => $gap || '16px'};
  padding: 0 24px 0 16px;

  @media only screen and (max-width: ${PolarisBreakPoint.LG}) {
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ $gapResponsive }) => $gapResponsive || '16px'};
  }
`;

export const IconWrapper = styled.div``;

export const ListItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const Bullet = styled.span`
  color: var(--p-color-text-secondary);
  font-size: 14px;
  line-height: 20px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 8px;
  right: 8px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--p-color-text-secondary);
  border-radius: 4px;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
    color: var(--p-color-text);
  }

  svg {
    width: 23px;
    height: 23px;
  }
`;
